<template>
  <v-layout class="d-flex flex-no-wrap" justify-center>
    <slot name="prependButton"></slot>
    <div>
      <v-btn v-if="!hideView" icon small class="mx-0" @click="onView">
        <v-icon small color="cyan">mdi-file-find</v-icon>
      </v-btn>
    </div>
    <div>
      <v-btn
        v-if="!hideEdit && !agGridViewOptions.hideEdit"
        icon
        small
        class="mx-0"
        @click="onEdit"
      >
        <v-icon color="teal" small>mdi-pencil</v-icon>
      </v-btn>
    </div>
    <slot name="extraButton"></slot>
    <div v-if="agGridViewOptions.showClone">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon small class="mx-0" @click="cloneItem(item)">
            <v-icon color="primary" small>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>Copy</span>
      </v-tooltip>
    </div>
    <confirmation-dialog @onConfirm="onRemoveAccept">
      <v-btn v-if="!removeVisible" icon small class="mx-0">
        <v-icon small color="pink">mdi-delete</v-icon>
      </v-btn>
      <template slot="message">{{ confirmationMessage }}</template>
    </confirmation-dialog>
    <slot name="appendButton"></slot>
    <div v-if="debug">
      {{ itemData }}
    </div>
  </v-layout>
</template>
<script>
import ConfirmationDialog from "./ConfirmationDialog";

export default {
  name: "DefaultListActions",

  components: {
    ConfirmationDialog,
  },

  props: {
    item: { type: Object },
    itemName: {
      type: String,
      default: "",
    },
    hideView: {
      type: Boolean,
      default: () => true,
    },
    hideEdit: {
      type: Boolean,
      default: () => false,
    },
    hideRemove: {
      type: Boolean,
      default: () => false,
    },
    deleteWarning: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      removeDialog: false,
    };
  },

  computed: {
    removeVisible() {
      //7228 - ag-grid sux!
      return (
        this.hideRemove ||
        this.itemData.hasClientInvoice ||
        this.itemData.hasPurchaseInvoice ||
        this.agGridViewOptions.hideRemove
      );
    },
    confirmationMessage() {
      return this.deleteWarning != ""
        ? this.deleteWarning
        : `This will remove ${this.itemLabel}`;
    },
    itemLabel: function () {
      return this.item && this.item.node
        ? `${this.item.node.__typename}`
        : this.itemName || "Item";
    },
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
    agGridViewOptions() {
      //taken from getter
      return this.params &&
        this.params.value &&
        this.params.value.agGridViewOptions
        ? this.params.value.agGridViewOptions
        : {
            hideRemove: false,
            hideEdit: false,
            showClone: false,
          };
    },
  },

  methods: {
    onView() {
      if (this.params) {
        this.params.context.componentParent.viewItem(this.itemData);
      } else {
        this.$emit("viewItem", { ...this.item });
      }
    },
    onEdit() {
      if (this.params) {
        this.params.context.componentParent.editItem(this.itemData);
      } else {
        this.$emit("editItem", this.itemData);
      }
    },
    cloneItem(item) {
      if (this.params) {
        this.params.context.componentParent.cloneItem(this.itemData);
      } else {
        this.$emit("cloneItem", this.itemData);
      }
    },
    onRemoveAccept() {
      this.removeDialog = false;
      if (this.params) {
        this.params.context.componentParent.deleteItem(this.itemData);
      } else {
        this.$emit("deleteItem", this.itemData);
      }
    },
    hasAccessTo(actionName) {
      const map = {
        Itinerary: "itineraries",
        Supplier: "suppliers",
        Client: "clients",
        Agent: "administration_panel",
      };
      if (this.item.hasOwnProperty("node")) {
        if (this.item.node.__typename == "Agent") {
          actionName = actionName + "_agent";
        }
        return map[this.item.node.__typename] != null
          ? this.$store.getters.hasAccessTo(
              `${map[this.item.node.__typename]}:${actionName}`
            )
          : true;
      } else {
        return true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/shared/DefaultListActions.vue